<template>
  <div
    class="modal fade"
    id="deleteItemModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="shareModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            id="shareModalLabel"
          >
            Delete
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.capture="onCloseModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          Are you sure you want to delete this item?
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click.prevent="onCloseModal"
          >
            Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click.prevent="onDeleteVideo"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'delete-warning',
  methods: {
    onCloseModal() {
      $('#deleteItemModal').modal('hide');
    },
    onDeleteVideo() {
      this.$emit('handleRemovedItem');
    },
  },
};
</script>
